/**
 * Servicio para envío de emails desde el sitio institucional SASA-WEB.
 * Integrado con backend ASP.NET Core (POST /api/Contacto/EnviarContacto).
 */

export class ContactoService {
    /**
     * Envía un email de contacto desde el formulario.
     * @param {Object} data - { nombre, email, mensaje }
     * @returns {Promise} - Promesa que resuelve con respuesta del backend o lanza Error.
     */
    static async enviarContacto(data) {
        try {
            const dto = {
                Nombre: data.nombre,
                Mail: data.email,
                Mensaje: data.mensaje
            };

            const response = await fetch('/api/Contacto/EnviarContacto', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dto)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({
                    mensaje: 'Error al enviar el email'
                }));

                throw new Error(errorData.mensaje || 'Error al enviar el email');
            }

            return await response.json();

        } catch (error) {
            console.error('Error al enviar email de contacto:', error);
            throw error;
        }
    }
}
